import styled, { css } from 'styled-components';

import { Link } from '@powdr/components';
import {
  ThemeProps as Prop, Breakpoints, FontFamily, FontSize,
  Components,
} from '@powdr/constants';
import { getFontConfigValues, getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.COUNTDOWN_CLOCK;

export const StyledCountdownClock = styled.div`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  ${({ $flipClockVersion }) => (($flipClockVersion) ? '' : `
    margin: 20px 0;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  `)};
  text-align: center;
`;

export const ClockTitle = styled.h3`
  margin-bottom: 15px;
`;

export const ClockParts = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5%;

  .flip-clock {
    justify-content: center;

    > .flip-clock-group {
      
      > .flip-clock-group-items {
        gap: 30px;
      }
    }

    .flip-clock-divider {
      display: none;
    }

    .flip-clock-label {
      color: ${({ $colorProfile }) => themeUtil(Prop.HEADER, CPNT, $colorProfile)};
      ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG40, undefined, undefined)};
    }

    .flip-clock-card-item-inner {
      .bottom, .top {
        font-family: ${() => getFontConfigValues(FontFamily.PRIMARY_FONT).fontFamily};
        color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, $colorProfile)} !important;
        background: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, $colorProfile)} !important;
      }
    }
  }

  ${Breakpoints.portrait(css`
    .flip-clock {
      --width: .8em;

      > .flip-clock-group {
        
        > .flip-clock-group-items {
          gap: 20px;
          justify-content: center;
          flex-wrap: wrap;
        }
      }
    }

    
  `)}

  ${Breakpoints.mobile(css`
    gap: 10%;

    .flip-clock {
      .flip-clock-label {
        ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG20, undefined, undefined)};
      }
    }
  `)}
`;

export const ClockPart = styled.div``;

export const Value = styled.div`
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.LRG20, undefined, undefined)};
`;

export const Label = styled.div`
  ${() => getFontStyles(FontFamily.BASE_FONT, FontSize.REG40, undefined, undefined)};
`;

export const Button = styled(Link)`
  margin: 15px 0 0 0;
  ${() => getFontStyles(FontFamily.SECONDARY_FONT, undefined, undefined, undefined)};
  line-height: 1;
  border: none;
  cursor: pointer;
  display: inline-block;
  position: relative;
  text-align: center;
  width: auto;
  height: auto;
  padding: 16px 20px;
  text-transform: none;
  color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, $colorProfile)};
  background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, $colorProfile)};
  transition: color .25s ease-out, background-color .25s ease-out;

  &:hover, &:focus {
    transition: color .25s ease-out, background-color .25s ease-out;
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, $colorProfile)};
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
  }

  &:focus {
    outline: 2px solid ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
    outline-offset: 2px;
  }
`;
